import { langOf } from "../langs";

export const secondStepFields = [
   {
     title: "Вікова група", 
     formName: "ageGroup",
     selectOptions: [
       {name: "Діти 6-12", value: "kids"},
       {name: "Підлітки 13-17", value: "teenagers"},
       {name: "Дорослі", value: "adults"}
     ]
   },
   {
     title: "Зазначений рівень володіння", 
     formName: "englishLevel",
     selectOptions: [
       {name: "Starter", value: "starter"},
       {name: "Beginner", value: "beginner"},
       {name: "Elementary", value: "elementary"},
       {name: "Pre-Intermediate", value: "pre-intermediate"},
       {name: "Intermediate", value: "intermediate"},
       {name: "Upper-Intermediate", value: "upper-intermediate"}
     ]
   },
]

// Пробний іспанської: рівні A1–B2 (пробний якраз і визначає рівень)
export const secondStepFieldsFor = (lang) =>
   lang === "es"
      ? [secondStepFields[0], { ...secondStepFields[1], selectOptions: langOf("es").levels.map((level) => ({ name: level, value: level })) }]
      : secondStepFields
